<template>
    <div id="app">
        <router-view :key="$route.meta && $route.meta.cache ? false : $route.fullPath"/>
    </div>
</template>

<script>
import ls from 'local-storage';
// import cookie from 'js-cookie';
var md5 = require('js-md5');
import CryptoJS from 'crypto-js';

import {getUserInfo,getMenuList, fetchAccessToken} from '@/assets/js/commonApi';
export default {
    name: "App",
    data(){
        return{
            timer: null
        }
    },
    computed:{
        userInfo(){
            return this.$store.state.userInfo || ls.get("userInfo");
        },
        menuList(){
            return this.$store.state.menuList || ls.get("menuList");
        },
        accessToken(){
            return this.$store.state.accessToken;
        }
    },
    created(){
        const _token = ls.get('token');
        if(!_token){
            ls.set('token',md5( this.$utils.uuid(32).toLowerCase() ))
        }

        const _sign = ls.get('CUSUT');

        if( _sign && !this.userInfo ){
            getUserInfo();
        }else{
            this.$store.commit('setUserInfo',this.userInfo);
        }

        if( _sign && !this.menuList){
            getMenuList();
        }else{
            this.$store.commit('setMenuList',this.menuList);
        }
    },
    watch:{
        //accessToken 轮询
        accessToken(v){
            clearInterval(this.timer);
            let _accessTokenTime = 600;
            if(v){
                const _b = v.split('.')[1];
                _accessTokenTime = CryptoJS.enc.Base64.parse( _b );
                _accessTokenTime = _accessTokenTime.toString(CryptoJS.enc.Utf8);
                _accessTokenTime = JSON.parse(_accessTokenTime);
                _accessTokenTime = _accessTokenTime.exp - _accessTokenTime.iat - 30;
            }
            
            this.timer = setInterval(() => {
                fetchAccessToken();
            }, _accessTokenTime * 1000);
        }
    }
};
</script>

<style lang="scss">
@import "@/assets/css/common.scss"
</style>
